import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { get, find, has } from 'lodash';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl, SanitizeHtml, SmoothLink } from '@bd/bdcore-utilities';
import { getCommunityRouteProps } from '@bd/bdcore-data/build/Communities/selectors';
import LightBox from '@bd/bdui-lightbox';
import Map from '@bd/bdui-coremap';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';


import Header from '../../components/Header';
import Footer from '../../components/Footer';
import CtaBanner from '../../components/CtaBanner';
import TestimonialBanner from '../../components/TestimonialBanner';
import HomeCard from '../HomesOriginal/HomeCard';
import CommunityCard from '../Communities/CommunityCard';
import ContactModal from '../../components/ContactModal';
import PlanAgent from './PlanAgent';

function getCommunityModelProperty(community, plan, field) {
  let communityMatch = null;
  if (community) {
    communityMatch = find(plan.communities, ['community', community._id]);
  }
  return get(communityMatch, `communityModelProperties.${field}`, get(plan, field));
}

function calculateHersPosition(rating) {
  const max = 150;
  const start = -0.01;
  const end = 0.945;

  const range = end - start;

  const scale = (rating / max) * 100;

  const result = (scale * range) + (start * 100);

  return { left: `${result}%` };
}


class PlanDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showInteractive: true,
    };

    this.onKovaError = this.onKovaError.bind(this);
  }

  onKovaError() {
    this.setState({
      showInteractive: false,
    });
  }

  render() {
    const { community, plan, homes, communities, metro, submetro } = this.props;

    const background = {};
    if (has(plan, 'photos[0].contentUrl') || has(plan, 'elevationPhotos[0].contentUrl')) {
      background.backgroundImage = buildThumbnailUrl(get(plan, 'photos[0].contentUrl', get(plan, 'elevationPhotos[0].contentUrl')), { width: 1000, height: 1000 });
    } else {
      background.backgroundImage = '/images/comming-soon.jpg';
    }
    return (
      <div className="planDetail">
        <PageHelmet plan={plan} />
        <Header />
        <div className="detail-header">
          <div className="container">
            <div className="row">
              <nav
                aria-label="breadcrumb"
                className={css`
                  width: 100%;
                  `}
              >
                <ol className="breadcrumb breadcrumb-plan">
                  <li className="breadcrumb-item">
                    <Link name="index">Home</Link>
                  </li>
                  <li className="breadcrumb-item"><Link name="plans">Floor Plans</Link></li>
                  {
                    community &&
                    <li className="breadcrumb-item"><Link name="community-detail" params={getCommunityRouteProps(community)} hash="#plans">{get(community, 'name')}</Link></li>
                  }
                  <li className="breadcrumb-item active" aria-current="page">{get(plan, 'name')}</li>
                </ol>
              </nav>
            </div>
            <div className="row">
              <div className="col-md-7 order-md-2 detail-header-media" style={{ backgroundImage: `url('${background.backgroundImage}')` }}>
                <LightBox
                  items={get(plan, 'photos', []).concat(get(plan, 'elevationPhotos', []))}
                  button={(
                    <a className="detail-media-photo-counter">
                      <img src="/images/icon-camera.svg" alt="Camera Icon" /><br />
                      {(get(plan, 'photos', [])).concat(get(plan, 'elevationPhotos', [])).length}
                    </a>
                  )}
                />
              </div>
              <div className="col-md-5 order-md-1 detail-header-content">
                <h1><span>the</span><br />{get(plan, 'name')}</h1>
                {
                  get(community, 'name') &&
                  <h3 className="PlanCommunity_name">in <Link name="community-detail"community={community}>{community.name}</Link></h3>
                }
                {
                  community &&
                  getCommunityModelProperty(community, plan, 'price') &&
                  <div className="row row-minus-30">
                    <div className="col-md-12 detail-header-price">
                      <span>Priced from</span> {numeral(getCommunityModelProperty(community, plan, 'price')).format('$0,0')}
                    </div>
                  </div>
                }
                <ul className="detail-header-list2">
                  <li>
                    <img src="/images/icon-beds-white.svg" alt="Bed Icon" /><br />
                    <strong>{getCommunityModelProperty(community, plan, 'beds')}</strong><br />  Beds
                  </li>
                  <li>
                    <img src="/images/icon-baths-white.svg" alt="Bath Icon" /><br />
                    <strong>{getCommunityModelProperty(community, plan, 'bathsFull')}</strong><br />  Baths
                  </li>
                  <li>
                    <img src="/images/icon-sqft-white.svg" alt="Square Feet Icon" /><br />
                    <strong>{numeral(getCommunityModelProperty(community, plan, 'sqft')).format('0,0')}</strong><br />  SQ FT
                  </li>
                  {
                   !!get(plan, 'stories', get(plan, 'stories')) &&
                   <li>
                     <img src="/images/icon-sqft-white.svg" alt="Square Feet Icon" /><br />
                     <strong>{getCommunityModelProperty(community, plan, 'stories')}</strong><br />Stories
                    </li>
                  }
                  {
                   !!get(plan, 'garages', get(plan, 'garages')) &&
                   <li>
                     <img src="/images/icon-sqft-white.svg" alt="Square Feet Icon" /><br />
                     <strong>{getCommunityModelProperty(community, plan, 'garages')}</strong><br />Garages
                   </li>
                  }
                </ul>
                <ul className="detail-header-list1">
                  {
                    get(plan, 'description') &&
                    <li><SmoothLink href="#details">Description</SmoothLink></li>
                  }
                  {
                    plan.floorplanPhotos.length !== 0 &&
                    <li><LightBox
                      items={(get(plan, 'floorplanPhotos', []))}
                      button={(
                        <a className="btn-plan-link">Floor Plan</a>
                      )}
                    /></li>
                  }
                  {
                    !!get(plan, 'virtual_tour') &&
                    <li><SmoothLink href="#virtual-tour">Virtual Tour</SmoothLink></li>
                  }
                  {
                    !!get(plan, 'hers_rating') &&
                    <li><SmoothLink href="#hers">Rating</SmoothLink></li>
                  }
                  {
                    communities.length > 0 &&
                    <li><SmoothLink href="#built-in">Built In</SmoothLink></li>
                  }
                  {
                    homes.length > 0 &&
                    <li><SmoothLink href="#available">Available Now</SmoothLink></li>
                  }
                  {
                    !!get(plan, 'brochure') &&
                    <li className="plan-brochure"><a href={plan.brochure.contentUrl} target="_blank">Download The Brochure</a></li>
                  }
                  <li><ContactModal className="btn btn-hollow ml-auto">Interested In The {plan.name}</ContactModal></li>
                </ul>
                {
                  communities &&
                  <ul className="detail-header-list2 d-none">
                    <li>
                      <a>
                        <img src="/images/icon-area-map.svg" alt="Area Map Icon" /><br />
                        {get(metro, 'name')} {get(metro, 'state')}<br />{get(submetro, 'name')}
                      </a>
                    </li>
                    <li>
                      <a>
                        <img src="/images/icon-communities.svg" alt="Community Icon" /><br />
                        {get(communities, 'name')}<br />Community
                      </a>
                    </li>
                  </ul>
                }
              </div>
            </div>
          </div>
        </div>
        {
          get(plan, 'description') &&
          <div className="detail-content" id="details">
            <div className="container">
              <div className="row">
                <div className="col-12 ">
                  <h4>About this Plan</h4>
                  <p className="big-p" dangerouslySetInnerHTML={SanitizeHtml(get(plan, 'description'))} />
                </div>
              </div>
            </div>
          </div>
        }
        {
          !!get(plan, 'matterport_tours') &&
          <div className="detail-virtual-tour" id="virtual-tour">
            <div className="container">
              <h4>Virtual Tour</h4>
              <div className="row">
                <div className="col-12 col-lg-8 mx-auto">
                  <img src="/images/detail-virtual-tour-photo-fpo.jpg" alt="Virtual Tour" />
                  <LightBox
                    items={[
                      {
                        element: (
                          <div
                            style={{
                              width: '800px',
                              maxWidth: '80%',
                              margin: '-225px auto 0 auto',
                              top: '50%',
                            }}
                            className="embed-responsive embed-responsive-16by9"
                          >
                            <iframe
                              src={get(plan, 'matterport_tours')}
                              frameBorder="0"
                              title="Matterport Tour"
                            />
                          </div>
                        ),
                      },
                    ]}
                    button={(
                      <div className="video-btn clickable" />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="background" />
          </div>
        }

        {
          !!get(plan, 'virtual_tour') &&
          <div className="detail-plan-virtual-tour" id="virtual-tour">
            <div className="container">
              <h4>Virtual Tour</h4>
              <div className="row">
                <div className="col-12 col-lg-8 mx-auto">
                  <iframe
                    src={get(plan, 'virtual_tour')}
                    frameBorder="0"
                    title="Matterport Tour"
                  />
                </div>
              </div>
            </div>
            <div className="background" />
          </div>
        }
        {
          !!get(plan, 'hers_rating') &&
          <div className="section-pd" id="hers">
            <div className="container">
              <div className="row">
                <div className="col-xl-6 hers-content">
                  <h3>Hers Rating</h3>
                  <h4>(Home Energy Rating)</h4>
                  <p>
                    The HERS (Home Energy Rating Systems) rating provides a
                    standardized evaluation of a home&rsquo;s energy efficiency and
                    average energy savings.
                  </p>
                  <p className="small">
                    *The HERS Rating for each plan will vary by market. The values
                    indicated reflect an average rating for this base plan.
                  </p>
                  <div className="hers-score-box">
                    <div className="rating">
                      <span>{get(plan, 'hers_rating')}<sup>*</sup></span><br />Rating
                    </div>
                    {
                      !!get(plan, 'hers_savings') &&
                      <div className="savings">
                        <span>{get(plan, 'hers_savings')}</span><br />Savings
                      </div>
                    }
                  </div>
                </div>
                <div className="col-xl-6 hers-graphic">
                  <span className="hers-graphic-container">
                    <img src="/images/hers-graphic-bar.svg" alt="" />
                    <div className="indicator" style={calculateHersPosition(get(plan, 'hers_rating'))} />
                  </span>
                </div>
              </div>
            </div>
          </div>
        }
        {
          homes.length > 0 &&
          <div className="additional-homes" id="available">
            <div className="full-width-headline">
              <h3>Available Now</h3>
              <div className="lines" />
            </div>
            <div className="AvailableHomes_wrapper">
              <div className="container">
                <div className="row HomeCardsList Vertical">
                  {
                    homes.map(home => (
                      <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3 mb-3" key={home._id}>
                        <HomeCard home={home} key={home._id} />
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
        }
        {
          communities.length > 0 &&
          <div className="built-in" id="built-in">
            <div className="full-width-headline">
              <h3>Built In These Communities</h3>
              <div className="lines" />
            </div>
            <div className="container">
              <div className="row CommunityCardsList">
                <div className="col-12" style={{ height: '600px' }}>
                  <Map
                    className={css`
                      height: 100%;
                      .leaflet-container {
                        height: 100%;
                      }
                      `}
                    markers={communities}
                    pin={{
                      iconUrl: '/images/icon-map-pin-blue.svg',
                      iconSize: [21, 30],
                      iconAnchor: [11, 30],
                      popupAnchor: [0, -35],
                    }}
                    pins={[
                      {
                        iconUrl: '/images/map-pin-blue.svg',
                        when: marker => marker.is_sovereign,
                      },
                    ]}
                    popup={({ marker: builtInCommunity }) => (
                      <div className="community-popup">
                        <CommunityCard community={builtInCommunity} hideMapPin />
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        }

        <PlanAgent />
        <CtaBanner />
        <TestimonialBanner />
        <Footer />
      </div>
    );
  }
}

PlanDetail.propTypes = {
  community: PropTypes.object,
  plan: PropTypes.object,
  homes: PropTypes.arrayOf(PropTypes.object),
  communities: PropTypes.arrayOf(PropTypes.object),
  metro: PropTypes.object,
  submetro: PropTypes.object,
};

PlanDetail.defaultProps = {
  community: undefined,
  plan: undefined,
  homes: undefined,
  communities: undefined,
  metro: undefined,
  submetro: undefined,
  widget: undefined,
};

export default withData({
  plan: true,
  homes: true,
  communities: true,
  community: true,
  metro: true,
  submetro: true,
}, {
  required: {
    plan: true,
    widget: true,
  },
})(PlanDetail);



// WEBPACK FOOTER //
// ./src/pages/Plans/PlanDetail.js